import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ActivityStatus } from "~app/common/models/constants";
import { AnvandareService } from "~app/common/services/anvandare.service";
import { ActivityViewModel } from "~app/pages/start/aktiviteter/ActivityViewModel";
import { BlockComponent } from "../../container-block/block.component";
import { IconButtonComponent } from "../../icon-button/icon-button.component";
import { IconComponent } from "../../icon/icon.component";
import { ListColumnDirective } from "../../list/list-column.directive";
import { ListComponent } from "../../list/list.component";
import { RaskModalService } from "../../modal/rask-modal.service";
import { FooterActivityDetailsComponent } from "../footer-activity-details/footer-activity-details.component";

@Component({
    selector: "rask-footer-activity-popover",
    templateUrl: "./footer-activity-popover.component.html",
    styleUrls: ["./footer-activity-popover.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        BlockComponent,
        ListComponent,
        ListColumnDirective,
        RouterLink,
        IconComponent,
        IconButtonComponent
    ]
})
export class FooterActivityPopoverComponent {
    @Input() aktiviteter: ActivityViewModel[];

    private readonly anvandareService = inject(AnvandareService);
    private readonly raskModalService = inject(RaskModalService);

    dismissActivity(id: number) {
        this.anvandareService.dismissActivities([id], true);
    }

    getStatusIcon(status: string) {
        return this.anvandareService.getActivityStatusIcon(status);
    }

    openDetails(row: ActivityViewModel) {
        this.raskModalService.open("Aktivitetsdetaljer", FooterActivityDetailsComponent,  "xl", true, row);
    }

    showDismiss(row: ActivityViewModel): boolean {
        return row.status === ActivityStatus.Fel;
    }
}
